/** Limits and pacing for the chunked course certificate upload.
 *
 * MAX_BATCH_FILES and MAX_FILE_BYTES mirror the CLE API's own caps
 * (MAX_COURSE_CERTIFICATE_BATCH_UPLOAD and MAX_UPLOAD_FILE_BYTES). The file
 * count cap is load-bearing here, not just a nicety: the API compares its
 * batch limit against the index *within one request*, so once we split a
 * selection into chunks the server can no longer enforce it and this is the
 * only cap left. */
export const MAX_BATCH_FILES = 50;
export const MAX_FILE_BYTES = 5 * 1024 * 1024;

/** A chunk is bounded by both a file count and a byte total, so a chunk of
 * large-but-legal PDFs cannot grow big enough to threaten CHUNK_TIMEOUT_MS. */
export const CHUNK_FILE_COUNT = 5;
export const CHUNK_MAX_BYTES = 8 * 1024 * 1024;

export const CHUNK_CONCURRENCY = 3;

/** Deliberately *above* the BFF's 100 s HttpClient default, so a stalled
 * upload surfaces as the server's own error (with a status and body) rather
 * than a blind client abort we cannot diagnose. */
export const CHUNK_TIMEOUT_MS = 120_000;

/** Retries per chunk, on top of the first attempt. React Query mutations do
 * not retry at all, and this upload no longer runs through one. */
export const CHUNK_RETRY_ATTEMPTS = 1;
